import {GetterTree, MutationTree, ActionTree} from 'vuex'
import {RoomsState} from '@/store/types'
import axios from 'axios'

type RoomsGetter = GetterTree<RoomsState, any>
type RoomsMutation = MutationTree<RoomsState>
type RoomsAction = ActionTree<RoomsState, any>

const state: RoomsState = {
  rooms: [],
  roomTypes: [],
  activeRoomId: 0,
}


const getters: RoomsGetter = {
  rooms: (state) => state.rooms,
  roomTypes: (state) => state.roomTypes,
  roomTypesWithoutCustom: (state) => {
    return state.roomTypes.filter((r) => r.name !== 'Custom')
  },
  activeRoom: (state) => {
    const room = state.rooms.find((r) => r.id === state.activeRoomId)
    if (room === undefined) {
      return null
    }
    return room
  },
  activeRoomId: (state) => state.activeRoomId,
}

const mutations: RoomsMutation = {
  setRooms: (state, rooms) => {
    state.rooms = rooms
  },
  setRoomTypes: (state, rooms) => {
    state.roomTypes = rooms
  },
  setActiveRoomId: (state, roomId) => {
    state.activeRoomId = roomId
  },
  removeRoom: (state, room) => {
    state.rooms = state.rooms.filter((r) => r.id !== room.id)
  },
  addRoom: (state, room) => {
    state.rooms.push(Object.assign({}, room))
  },
  updateRoom: (state, room) => {
    state.rooms = state.rooms.map((r) => {
      if (r.id === room.id) {
        return room
      }
      return r
    })
  },
}

const actions: RoomsAction = {
  getRoomTypes: ({commit}) => {
    return new Promise((resolve, reject) => {
      axios.get('rooms').then((response) => {
        commit('setRoomTypes', response.data.data)
        resolve(response.data.data)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  addRoom: ({commit}, payload) => {
    return new Promise((resolve, reject) => {
      axios.post('lead-rooms', payload).then((response) => {
        commit('addRoom', response.data.data)
        resolve(response.data.data)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  editRoom: ({commit}, payload) => {
    return new Promise((resolve, reject) => {
      axios.put(`lead-rooms/${payload.id}`, payload).then((response) => {
        commit('updateRoom', response.data.data)
        resolve(response.data.data)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  removeRoom: ({commit}, payload) => {
    return new Promise((resolve, reject) => {
      axios.delete(`lead-rooms/${payload.id}`).then((response) => {
        commit('removeRoom', payload)
        commit('removeRoomInventory', payload.id)
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}
